import { render, staticRenderFns } from "./RewardGridTiles.vue?vue&type=template&id=4d68edf6&scoped=true&"
import script from "./RewardGridTiles.vue?vue&type=script&lang=js&"
export * from "./RewardGridTiles.vue?vue&type=script&lang=js&"
import style0 from "./RewardGridTiles.vue?vue&type=style&index=0&id=4d68edf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68edf6",
  null
  
)

export default component.exports